export default "__VITE_ASSET__af00afbb__"